import React from "react";
import ENV from "../env.json";

export default function NotFound() {
  return (
    <div className="w-100 h-100 d-flex align-items-center justify-content-center">
      <img src={ENV.RES_URL + '404.png'} alt="" style={{ width: 'auto', height: 'auto', maxWidth: '80%', maxHeight: '80%' }} />
    </div>
  );
}
